import { BuildingType } from '../../../types';
import type { Grid } from '../../../types';
import { GRID_SIZE } from '../../../constants';

/** Create playable starter grid with HUB, pipeline, and complaints office */
export function createInitialGrid(): Grid {
  const grid: Grid = [];
  const center = Math.floor(GRID_SIZE / 2);
  for (let y = 0; y < GRID_SIZE; y++) {
    const row = [];
    for (let x = 0; x < GRID_SIZE; x++) {
      row.push({ x, y, buildingType: BuildingType.None, level: 1, isConnected: false });
    }
    grid.push(row);
  }
  grid[center][center] = {
    x: center,
    y: center,
    buildingType: BuildingType.Core,
    level: 1,
    isConnected: true,
  };
  grid[center][center + 2] = {
    x: center + 2,
    y: center,
    buildingType: BuildingType.OpsComplaints,
    level: 1,
    isConnected: true,
  };
  grid[center][center + 1] = {
    x: center + 1,
    y: center,
    buildingType: BuildingType.Pipeline,
    level: 1,
    isConnected: true,
  };
  return grid;
}